// 题目类型中文名映射
export const typeNames: Record<string, string> = {
  single_choice: '单选题',
  multi_choice: '多选题',
  judge: '判断题',
  subjective: '主观题',
  python_coding: 'Python编程题',
  cpp_coding: 'C++编程题',
  scratch_coding: 'Scratch编程题',
  graphics: 'Scratch编程题',
  coding: '编程题'
};

// 题目子类型中文名映射
export const subTypeNames: Record<string, string> = {
  scratch: 'Scratch编程题',
  python: 'Python编程题',
  cpp: 'C++编程题',
  graphics: 'Scratch编程题',
  python_coding: 'Python编程题',
  cpp_coding: 'C++编程题'
};